import React, { forwardRef, useLayoutEffect, useEffect, useState, useRef, useImperativeHandle} from "react";
import {addCalenderItem, hideModal} from '@/reducers/ModalPopup';
import store from "@/redux/store";
import {storeCalenderSettings, setSelectedDate, getTasks, setSelectedUsers} from '@/reducers/CommunicationCycle';

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import CalenderHelperClass from '@/helpers/CalenderHelper'

import moment from 'moment';
import CalenderItem from './CalenderItem'
import EventItem from './EventItem'
import { useTranslation, withTranslation, Trans } from "react-i18next";
import AddEventButtons from "./AddEventButtons"
import { SelectBox } from "@/components/holders/SelectBox";


import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import FilterPanel from "./FilterPanel";
import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  EllipsisHorizontalIcon,
} from '@heroicons/react/20/solid'



const CalenderMonth = function({...props}, ref) {
    
        const { t, i18n, ready } = useTranslation();
        
        //const [selectedUsers, setSelectedUsers] = useState(((props?.selectedUsers) ? props?.selectedUsers : []));

    let dayIndexHolder = {};
    /*
    let items = [];
    if(items.length == 0 && props?.items.length > 0) {
            items = [...props.items];
    }
    */
    const [onlyWeekends, setOnlyWeekends] = useState( (props?.calenderSettings && props?.calenderSettings?.onlyWeekends) ? props?.calenderSettings?.onlyWeekends : 0 );
    const [calenderType, setCalenderType] = useState( (props?.calenderSettings && props?.calenderSettings?.calenderviewtype) ? props?.calenderSettings?.calenderviewtype : 0 );
    const [items, setItems] = useState(props?.items);
    const [currentViewHolder, setCurrentViewHolder] = useState({});
    const [currentDate, setCurrentDate] = useState(((props?.selectedDate) ? props.selectedDate : moment()));
    const currentView = useRef<HTMLDivElement>(null);
    const events = useRef<HTMLDivElement>(null);
    const dayView = useRef<HTMLDivElement>(null);
    let dragOverElement = null;
    let dragItem = null;
    let days = CalenderHelperClass.getDaysForMonth(currentDate);
    
    let loggedInUser = store.getState().AuthReducer.user;
    useImperativeHandle(ref, () => ({
        getAvailability: (fromDate, workhours) => {
            return "YES"
        },
        setCurrentValue: (value) => {
            
            setItems([...items]);
        }
    }));
        
        
        
    const toggleWeekendCalender=(event) => {
        event.preventDefault();
        store.dispatch( storeCalenderSettings({onlyWeekends:!onlyWeekends}) )
        setOnlyWeekends(!onlyWeekends);
        
        return false;
    }

    const setCalenderTypeEventHandler=(event, type) => {
        event.preventDefault();
        store.dispatch( storeCalenderSettings({viewtype:type}) )
        setCalenderType(type);
        return false;
    }
        
    const onItemClickEvent=(event, item) => {
        event.preventDefault();
             
         if(props?.showPreviewHandler) {
             props?.showPreviewHandler(event, item);
         }
     return false;
     };
     
    const addCalenderItemEvent=(event, eventTypeId) => {
        if(props?.showAddItemHandler)
            props?.showAddItemHandler(event, eventTypeId);
        }

    const onMouseEnterEvent=(event) => {
        event.target.style.background = "red";
//        let el = document.getElementById("eventKey_2");
//        el.style.background = "red";
        
    }

    const onMouseLeaveEvent=(event) => {
        event.target.style.background = null;
//        let el = document.getElementById("eventKey_2");
//        el.style.background = null;
        
    }

    const setCurrentDay=(event) => {
        let month = moment();
//        let key = "month"+currentDate.format("MM");
//        currentViewHolder[key] = currentView.current.innerHTML;
        //setCurrentViewHolder(currentViewHolder)
        store.dispatch( setSelectedDate(month) );
        setCurrentDate(month);
    }
    
    const monthBack=(event) => {
        let month = currentDate.clone().subtract(1, 'month');
//        let key = "month"+currentDate.format("MM");
//        currentViewHolder[key] = currentView.current.innerHTML;
//        setCurrentViewHolder(currentViewHolder)
        store.dispatch( setSelectedDate(month) );
        setCurrentDate(month);
    }
    const monthNext=(event) => {
        let month = currentDate.clone().add(1, 'month');
//        let key = "month"+currentDate.format("MM");
//        currentViewHolder[key] = currentView.current.innerHTML;
//        setCurrentViewHolder(currentViewHolder)
        store.dispatch( setSelectedDate(month) );
        setCurrentDate(month);
    }

/*    
    const  onDragStart=((event) => {
        //event.preventDefault();
        dragItem = event.target.cloneNode();
         
        event.dataTransfer.setData("text/html", event.target.id);
        event.dataTransfer.effectAllowed = "copy";  
     });
    const  onDragOver=((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy";
        if(dragOverElement) {
            dragOverElement.style.background = "#e8f1fd";
        }
        
        if(dragItem) {
            dragItem.style.left = (dragOverElement['offsetLeft']+30)+"px";
            dragItem.style.top = (dragOverElement['offsetTop']+5)+"px";
            dragItem.style.width = dragOverElement['width']+"px";
            dragItem.style.height = "20px";
            dragItem.style.background = "blue";
            
        } 
               
    })

    const onDragLeave=((event) => {
        if(dragOverElement) {
            dragOverElement.style.background = null;
        }
    })
    
    const onDragEnter=((event) => {
        if(dragOverElement) {
            dragOverElement.style.background = null;
        }
        dragOverElement = event.currentTarget;
        dragOverElement.style.background = "#e8f1fd";
    })    
    const onDragEnd=((event) => {
        event.preventDefault();

        if(dragOverElement && dragOverElement.style.background != "") {
            dragOverElement.style.background = null;
            let child = event.currentTarget;
            let eventIndex = child.dataset.eventindex;

                                        child.style.left = (dragOverElement['offsetLeft']+5)+"px";
                                        child.style.top = (dragOverElement['offsetTop']+35)+"px";
                                        child.style.width = (dragOverElement['offsetWidth']-10)+"px";
                                child.style.height = "20px";
            let selectedItem = {...items[eventIndex]};
            let currentDay = moment(selectedItem.dayKey, "YYYYMMDD");
            let dropElementDate = moment(dragOverElement.dataset.key, "YYYYMMDD");
            let dayDiff = dropElementDate.diff(currentDay, 'days');
            let start_at = moment(selectedItem.start_at);
            let end_at = moment(selectedItem.end_at);
            //start_at->
            
            
            
                start_at.add(dayDiff, 'days');
                end_at.add(dayDiff, 'days');
            
            
            child.dataset.day = dragOverElement.dataset.key;
            dayIndexHolder[dragOverElement.dataset.key] = dragOverElement.dataset.index;
            child.dataset.day = dragOverElement.dataset.key;
            child.dataset.index = dragOverElement.dataset.index;
            child.dataset.indexto = dragOverElement.dataset.index;
            child.html = "12";
            
            //data-index={dayIndexHolder[item.dayKey]} data-indexto={dayIndexHolder[item.dayKey]} data-eventIndex={index}>{item.name}</div>)
            
            selectedItem.dayKey = dragOverElement.dataset.key;
            selectedItem.changedDayKey= dragOverElement.dataset.key;
            selectedItem.start_at = start_at.valueOf();
            selectedItem.end_at = end_at.valueOf();
            selectedItem.name = "Mijn test";
            items[eventIndex] = selectedItem;
            setItems([...items]);
            //props.items[eventIndex] = selectedItem;
        
            
            //items[eventIndex].day = dragOverElement.dataset.day;
            //localStorage.setItem("events", JSON.stringify(items));            
            //dragOverElement.dataset.day;
            return true;
        }
        return false;
    })
 */
 useEffect(() => {    // Update the document title using the browser API    document.title = `You clicked ${count} times`;  });
        if(dayView && dayView.current && events && events.current) {
            let eventChildren:HTMLCollection = events.current['children'];
            for(let i in eventChildren) {
                let child: any = eventChildren[i];
                if(child.dataset) {
                        let calenderDayIndex = child.dataset.index;
                        let calenderDayIndexTo = child.dataset.indexto;
                        if(calenderDayIndex >= 0) {
                            if(calenderDayIndexTo > calenderDayIndex) {
                                for(let j = calenderDayIndex; j <= calenderDayIndexTo; j++) {
                                    let calenderItem:any = dayView?.current['children'][j];
                                    if(calenderItem) {
                                        child.style.left = (calenderItem['offsetLeft']+5)+"px";
                                        child.style.top = (calenderItem['offsetTop']+35)+"px";
                                        child.style.width = (calenderItem['offsetWidth']-10)+"px";
                                child.style.fontSize = ".75rem";
                                child.style.height = "20px";
                            }
                                    
                                }   
                            } else {
                            let calenderItem:any = dayView?.current['children'][calenderDayIndex];
                            if(calenderItem) {
                                child.style.left = (calenderItem['offsetLeft']+5)+"px";
                                child.style.top = (calenderItem['offsetTop']+35)+"px";
                                child.style.width = (calenderItem['offsetWidth']-10)+"px";
                                child.style.height = "20px";
                                child.style.fontSize = ".6rem";
                            }
                            }
                        }
                        //
                events.current.classList.remove("hidden")
                //if(child)
                } 
            }
         } 
    });
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  //return size;

const saveHandler=(index) => {
     if(props?.saveItemHandler) {
             props?.saveItemHandler(index);
         }
}
 
const selectedDay = days.find((day) => day.isSelected)
function classNames(...classes) {
    
  return classes.filter(Boolean).join(' ')
}
   let html = (
    <>
  
    
    
    
    <div  className={"lg:flex lg:h-full lg:flex-col calenderview viewtype_"+calenderType} key={currentDate.format("YM'")}>
      <header className="flex items-center justify-between border-b border-gray-200 px-6 py-4 lg:flex-none">
        <h1 className="text-base font-semibold text-gray-900">
          <time dateTime="2022-01">{currentDate.format("MMMM YYYY")}</time>
        </h1>
        <div className="flex items-center">

        
        
          <div className="ml-4 relative flex items-center rounded-md bg-white shadow-sm md:items-stretch">
            <button
              type="button"
              onClick={(event) => {monthBack(event)}}
              className="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50"
            >
              <span className="sr-only">Previous month</span>
              <ChevronLeftIcon className="size-5" aria-hidden="true" />
            </button>
            <button
                onClick={(event) => {setCurrentDay(event)}}
            
              type="button"
              className="hidden border-y border-gray-300 px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative md:block"
            >
              {t('calender.today')}
            </button>
            <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
            <button
                onClick={(event) => {monthNext(event)}}
              type="button"
              className="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50"
            >
              <span className="sr-only">Next month</span>
              <ChevronRightIcon className="size-5" aria-hidden="true" />
            </button>
          </div>
          {!props['viewType'] &&
          <div className="hidden md:ml-4 md:flex md:items-center">
            <Menu as="div" className="relative">
              <MenuButton
                type="button"
                className="flex items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                {t('calender.viewtype_'+calenderType)}
                <ChevronDownIcon className="-mr-1 size-5 text-gray-400" aria-hidden="true" />
              </MenuButton>

              <MenuItems
                transition
                className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="py-1">
                <MenuItem>
                  <button
                    onClick={(event) => setCalenderTypeEventHandler(event, 0)}
                    className="w-full text-left block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {t('calender.viewtype_0')}
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    onClick={(event) => setCalenderTypeEventHandler(event, 1)}
                    className="w-full text-left block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {t('calender.viewtype_1')}
                  </button>
                </MenuItem>
                </div>
              </MenuItems>
            </Menu>
            <div className="ml-2 h-6 w-px bg-gray-300" />

            
            
            </div>
            }
          <Menu as="div" className="relative ml-6 md:hidden">
            <MenuButton className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
              <span className="sr-only">Open menu</span>
              <EllipsisHorizontalIcon className="size-5" aria-hidden="true" />
            </MenuButton>

            <MenuItems
              transition
              className="absolute right-0 z-10 mt-3 w-36 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
              <div className="py-1">
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    Create event
                  </a>
                </MenuItem>
              </div>
              <div className="py-1">
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    Go to today
                  </a>
                </MenuItem>
              </div>
              <div className="py-1">
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    Day view
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    Week view
                  </a>
                </MenuItem>
                <MenuItem>
                  <button
                    onClick={(event) => setCalenderTypeEventHandler(event, 0)}
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {t('calender.viewtype_0')}
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    onClick={(event) => setCalenderTypeEventHandler(event, 1)}
                    className="w-full block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {t('calender.viewtype_1')}
                  </button>
                </MenuItem>
              </div>
            </MenuItems>
          </Menu>
                      <button
                      onClick={(event) => toggleWeekendCalender(event)}
              type="button"
              className="ml-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              {(onlyWeekends == 0) ? "Alleen werkdagen" : "incl. weekenden" }
            </button>

        </div>
      </header>
        <FilterPanel users={props?.users} loggedInUser={loggedInUser} viewType={props?.viewType} onUserSelectEvent={props?.onUserSelectEvent}/>        
      <div className="shadow ring-1 ring-black/5 lg:flex lg:flex-auto lg:flex-col">
        <div className={"grid "+((onlyWeekends) ? "grid-cols-5" : "grid-cols-7")+" gap-px border-b border-gray-300 bg-gray-200 text-center text-xs/6 font-semibold text-gray-700 lg:flex-none"}>
          <div className="bg-white py-2">
            M<span className="sr-only sm:not-sr-only">a</span>
          </div>
          <div className="bg-white py-2">
            D<span className="sr-only sm:not-sr-only">i</span>
          </div>
          <div className="bg-white py-2">
            W<span className="sr-only sm:not-sr-only">o</span>
          </div>
          <div className="bg-white py-2">
            D<span className="sr-only sm:not-sr-only">o</span>
          </div>
          <div className="bg-white py-2">
            V<span className="sr-only sm:not-sr-only">r</span>
          </div>
          {!onlyWeekends &&
          <> 
          <div className="bg-white py-2">
            Z<span className="sr-only sm:not-sr-only">a</span>
          </div>
          <div className="bg-white py-2">
            Z<span className="sr-only sm:not-sr-only">o</span>
          </div>
          </>
          }
        </div>
  
        
        <div className="flex bg-gray-200 text-xs/6 text-gray-700 flex-auto ">
          <div className={"grid grid-cols-"+((onlyWeekends) ? "5" : "7")+" relative w-full lg:grid grid-rows-6 gap-px"} id="days" ref={dayView} >
            {days.map((day, mindex) => {
                if(onlyWeekends && (day.weekDay == 7 || day.weekDay == 6)) {
                    return;
                }
                
                dayIndexHolder[day.year+day.month+day.day] = day.index;
                
                let dayItems = null;
                if(items  && items.has(day.key)) {
                    let dayItem = items.findOne(day.key, 'uid');
                    if(dayItem && dayItem.items.length > 0) {
                        dayItems = dayItem.items;
                    }
                }

                return(
                    <CalenderItem key={day.date} saveItemHandler={saveHandler} day={day} items={dayItems} dragOverClass="bg-red-900" className={classNames(
                  day.isCurrentMonth ? 'bg-white' : 'bg-gray-50 text-gray-500',
                  'relative px-3 py-2 min-h-24')} canDrop={(parseInt(day.day)==1) ? false : true}  onEventItemClickEvent={onItemClickEvent} viewType={props?.viewType} onClickDayHandler={props?.onClickDayHandler} />)
                  })}
          </div>

        </div>
      </div>
      <div id="eventHolder" className="hidden" ref={events}>
      
      </div>
      
      

    </div>
    </>
    )
    return html;   
}

export default forwardRef(CalenderMonth);

/*

        {items.map((item, index) => {
            
            return <EventItem item={item} 
                        className="event absolute cursor-pointer rounded bg-white text-sm p-.5 px-2 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        draggable={((calenderType == 1) ? true : true)}
                        />
//        return (<div id={item.id} className="event absolute cursor-pointer rounded bg-white text-sm p-.5 px-2 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" draggable={true} onDrop={(event) => {console.log("on drop",event)}} 
//        onDragStart={onDragStart} 
//        onDragEnd={CalenderItemDrag.onDragEndHandler} 
//        onMouseEnter={onMouseEnterEvent}
//        onMouseLeave={onMouseLeaveEvent}
//        onClick={(event) => {onItemClickEvent(event, item)}}
//        data-day={item.dayKey} data-index={dayIndexHolder[item.dayKey]} data-indexto={dayIndexHolder[item.dayKey]} data-eventIndex={index}>{item.name}</div>)
})}

*/